import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const FuneralTabPC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const handleNavigation = (route) => {
        navigate(route);
    };
    return (
        <>
            <nav className="funeral-methods-content-navigation">
                <div className="funeral-methods-content-nav-container">
                    <ul>
                        <li><a href="#" className={`${pathname === '/general-funeral-procedures' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/general-funeral-procedures'); }}>일반 장례절차</a></li>
                        <li><a href="#" className={`${pathname === '/funeral-information-religious' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/funeral-information-religious'); }}>종교별 장례절차</a></li>
                        <li><a href="#" className={`${pathname === '/funeral-methods' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/funeral-methods'); }}>장례방법</a></li>
                        <li><a href="#" className={`${pathname === '/funeral-information-other' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/funeral-information-other'); }}>기타</a></li>
                    </ul>
                </div>
            </nav>
        </>
    )
}

export default FuneralTabPC